import React from 'react';
import PropTypes from 'prop-types';
import InfoIconTooltip from './InfoTooltip';
import { setTitleFromSelectedOption } from '../utils';
import { Flex } from '@knockrentals/knock-shared-web-v2';

export const ASSIGNED_MANAGER_PLACEHOLDER = 'No eligible managers available';
export const ASSIGNED_MANAGER_TOOLTIP_MESSAGE =
  'Please use Assigned Manager only if you want the incoming leads to be auto-assigned to a user other than the Property Owner.';

export const getEligibleManagerOptions = (users, propertyOwnerId) =>
  users.reduce((options, user) => {
    const isPropertyOwner =
      user.owned_properties && user.owned_properties.length;
    const isCurrentPropertyOwner =
      String(user.user_id) === String(propertyOwnerId);

    if (!isPropertyOwner && !isCurrentPropertyOwner) {
      options.push(
        <option key={user.user_id} value={user.user_id}>
          {user.first_name} {user.last_name} ({user.email})
        </option>,
      );
    }
    return options;
  }, []);

const AssignedManagerSelect = ({
  assignedManagerId,
  isDisabled = false,
  onChange,
  propertyOwnerId,
  users,
}) => {
  const eligibleOptions = getEligibleManagerOptions(users, propertyOwnerId);

  const showFallback = eligibleOptions.length === 0 && !isDisabled;

  return (
    <Flex alignItems="center">
      {showFallback ? (
        <input
          aria-label="Assigned Manager"
          className="knock-react-input"
          disabled
          placeholder={ASSIGNED_MANAGER_PLACEHOLDER}
        />
      ) : (
        <select
          aria-label="Assigned Manager"
          className="manager-select"
          disabled={isDisabled}
          name="assignedManagerId"
          onChange={onChange}
          ref={(el) => setTitleFromSelectedOption(el)}
          value={assignedManagerId}
        >
          <option key="default" value="">
            --- Select User (optional) ---
          </option>
          {eligibleOptions}
        </select>
      )}
      <InfoIconTooltip message={ASSIGNED_MANAGER_TOOLTIP_MESSAGE} />
    </Flex>
  );
};

AssignedManagerSelect.propTypes = {
  assignedManagerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  propertyOwnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  users: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      owned_properties: PropTypes.arrayOf(PropTypes.object),
      user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ),
};

export default AssignedManagerSelect;
